import { Injectable, inject } from '@angular/core';
import {
  APIGatewayService,
  APIMessagingService,
  APINasService,
  APIPolicyService,
  APIWorkflowService,
  ApiService,
  APIUserService,
} from 'projects/shared/src/lib/services/api.service';
import { SDKBaseService } from 'ets-fe-ng-sdk';

@Injectable({
  providedIn: 'root',
})
export class BaseService extends SDKBaseService {
  protected override apiS = inject(ApiService);

  pget = this.get;
  ppost = this.post;
  protected deleteText<T>(path?: string) {
    return this.apiS.deleteText(this.formatRoute(this.baseURL + path || ''));
  }
}

@Injectable({
  providedIn: 'root',
})
export class BaseWorkflowService extends SDKBaseService {
  protected override apiS = inject(APIWorkflowService);

  pget = this.get;
  ppost = this.post;
  protected deleteText<T>(path?: string) {
    return this.apiS.deleteText(this.formatRoute(this.baseURL + path || ''));
  }
}

@Injectable({
  providedIn: 'root',
})
export class BaseGatewayService extends SDKBaseService {
  protected override apiS = inject(APIGatewayService);

  pget = this.get;
  ppost = this.post;
  protected deleteText<T>(path?: string) {
    return this.apiS.deleteText(this.formatRoute(this.baseURL + path || ''));
  }
}
@Injectable({
  providedIn: 'root',
})
export class BaseMessagingService extends SDKBaseService {
  protected override apiS = inject(APIMessagingService);
  protected deleteText<T>(path?: string) {
    return this.apiS.deleteText(this.formatRoute(this.baseURL + path || ''));
  }
}

@Injectable({
  providedIn: 'root',
})
export class BasePolicyService extends SDKBaseService {
  protected override apiS = inject(APIPolicyService);
  protected deleteText<T>(path?: string) {
    return this.apiS.deleteText(this.formatRoute(this.baseURL + path || ''));
  }
}

@Injectable({
  providedIn: 'root',
})
export class BaseUserService extends SDKBaseService {
  protected override apiS = inject(APIUserService);

  pget = this.get;
  ppost = this.post;
  protected deleteText<T>(path?: string) {
    return this.apiS.deleteText(this.formatRoute(this.baseURL + path || ''));
  }
}

@Injectable({
  providedIn: 'root',
})
export class BaseNasService extends SDKBaseService {
  protected override apiS = inject(APINasService);
}
